import { useEffect } from 'react';

type RefObject<T> = {
  readonly current: T | null;
};

type Callback = () => void;

function useOnClickOutside(ref: RefObject<HTMLElement>, callback: Callback) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    }

    // delay adding event listener to prevent closing the menu when it's opened (if it's opened on click outside of the ref element)
    const timeout = setTimeout(() => {
      document.addEventListener('click', handleClickOutside);
    }, 500);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      clearTimeout(timeout);
    };
  }, [ref, callback]);
}

export default useOnClickOutside;
